import { DEBUG_MODE } from './debug'
import {
  gumballStore, premioGumballStore, statoGumballStore, avvisoGumballStore, relockPointer,
} from '../store/uiStore'

// ============================================================
// LA MACCHINETTA DELLE PALLINE (Gumball.jsx + GumballPremio.jsx).
//
// Sta sul bancone, nel tratto LIBERO fra il POS e l'angolo: misurato con
// window.__sonda in ?debug, tutti i soprammobili cotti nel modello stanno
// fra z -4.65 e -3.30 (POS, registratore alto fino a 3.25, monitor), da
// z -3.15 a -1.20 il piano e' sgombro a y 1.98. Il lato del cliente e'
// x < 1.9 (li' la sonda trova il pavimento): il cliente sta da quella parte.
//
// UNITA': 1 unita' ≈ 0.55 m (vedi config/cassa.js). La macchinetta e'
// alta ~0.86 unita', cioe' mezzo metro abbondante: un po' piu' grande di
// una vera da banco, apposta — la si deve riconoscere e mirare da in
// piedi, e la pallina deve leggersi.
// ============================================================
// SPOSTATA VERSO DESTRA E GIRATA VERSO IL CENTRO DEL BANCONE (chiesto
// dall'utente). "Destra" e' quella di chi sta davanti al bancone, cioe' +Z,
// verso l'angolo: il tratto libero arriva fino a z -1.20 e oltre l'angolo il
// piano continua. La faccia con la manopola non guarda piu' dritta fuori
// (-90) ma il punto in cui sta il cliente davanti al CENTRO del bancone
// (0.8, -2.6): cosi' chi arriva a pagare la vede di tre quarti, girata
// verso di lui. giro = atan2(dx, dz) verso quel punto = -131.
// Girata cosi' l'ingombro sta ancora tutto sul piano: lo spigolo piu'
// esposto arriva a x ≈ 1.95, e il bordo del bancone e' a 1.8.
export const cfgGumball = {
  x: 2.25, y: 1.98, z: -1.35,
  giro: -131,
  scala: 1,
  portata: 3.2,       // distanza massima dalla macchinetta per usarla
  cono: 15,           // gradi: quanto dev'essere centrata nel mirino
}

// ============================================================
// L'ESTRAZIONE VERA STA SUL SERVER (api/gumball.js): premi, probabilita',
// codici Shopify e il limite di una giocata ogni 3 giorni. Qui si chiede
// e si mostra.
//
// SI ACCENDE DA VERCEL, NON DA QUI: con la variabile GUMBALL_ATTIVA=1 il
// server risponde "attiva" e la macchinetta compare sul bancone per tutti.
// Senza, in pubblico non c'e'. In ?debug c'e' sempre: se il server e'
// pronto gioca per davvero (anteprima, codici veri), altrimenti — in locale,
// dove api/ non esiste — fa una giocata di PROVA pescata qui, con la
// scritta "premio non reale".
// GIA' GIOCATO = MANOPOLA BLOCCATA, anche in ?debug (chiesto dall'utente:
// prima in ?debug partiva una giocata di prova, e sembrava che si potesse
// rigiocare). Per rigiocare in prova si cancella la chiave su Upstash.
// ============================================================

// Solo per le giocate di prova: stessa tabella del server, cosi' in ?debug
// si vede quello che vedranno i clienti. Quella che conta e' in api/.
const PREMI_PROVA = [
  { id: 'cinque',  peso: 25, colore: '#26a24a', titolo: 'Sconto 5%',         testo: 'Codice MOMOZ-PROVA', codice: 'MOMOZ-PROVA' },
  { id: 'sped',    peso: 15, colore: '#2f6fe0', titolo: 'Spedizione gratis', testo: 'Codice MOMOZ-PROVA', codice: 'MOMOZ-PROVA' },
  { id: 'ritenta', peso: 60, colore: '#f3f2ec', titolo: 'Ritenta!',          testo: 'Torna fra 3 giorni.' },
]

function pescaProva() {
  const totale = PREMI_PROVA.reduce((s, p) => s + p.peso, 0)
  let r = Math.random() * totale
  for (const p of PREMI_PROVA) {
    if ((r -= p.peso) < 0) return { ...p, prova: true }
  }
  return { ...PREMI_PROVA[PREMI_PROVA.length - 1], prova: true }
}

// I premi vinti, codice -> { titolo, id }, in localStorage: li scrive
// GumballPremio quando attacca il codice al carrello, li legge lo scontrino
// (Cassa.jsx). Il carrello Shopify sa solo il CODICE: senza questo lo
// scontrino direbbe "Codice sconto" invece di "Spedizione gratis".
export const CHIAVE_PREMI = 'momoz_premi'

// "fra 2 giorni", "fra 5 ore", "fra 20 minuti"
export function fraQuanto(quando) {
  const min = Math.max(1, Math.ceil((quando - Date.now()) / 60000))
  if (min >= 48 * 60) return `fra ${Math.round(min / 1440)} giorni`
  if (min >= 120) return `fra ${Math.round(min / 60)} ore`
  if (min >= 60) return 'fra un\'ora'
  return min === 1 ? 'fra un minuto' : `fra ${min} minuti`
}

// Da quell'IP si e' gia' giocato?
export const giaGiocato = () => statoGumballStore.get().prossima > Date.now()

// L'ultimo tentativo di girare una manopola bloccata: Gumball.jsx lo legge
// nel suo useFrame e la fa strattonare senza girare. Un oggetto piatto e non
// uno store, perche' non deve far ridisegnare niente.
export const manopolaBloccata = { da: -1e9 }

let avvisoTimer = 0
export function avvisa(testo) {
  avvisoGumballStore.set(testo)
  clearTimeout(avvisoTimer)
  avvisoTimer = setTimeout(() => avvisoGumballStore.set(null), 4500)
}

// Chiesto una volta all'avvio (GumballPremio). Se il server non risponde —
// in locale con `npm run dev` le funzioni api/ non esistono — resta il
// default: spenta in pubblico, prova in ?debug.
export async function caricaStatoGumball() {
  try {
    const r = await fetch('/api/gumball')
    const j = await r.json()
    const vera = Boolean(j.pronta) && (Boolean(j.attiva) || DEBUG_MODE)
    statoGumballStore.set({
      // la macchinetta sta sul bancone comunque: vedi la nota in uiStore
      visibile: true,
      // `funziona` e' esattamente quello che `avviaGiro` accetta piu' sotto:
      // se fosse solo `attiva` si prometterebbe una giocata anche col server
      // acceso ma senza Redis, e premendo E non succederebbe niente
      funziona: vera || DEBUG_MODE,
      vera,
      prossima: j.prossima || 0,
    })
  } catch {
    // resta il default
  }
}

// ============================================================
// UNA GIOCATA. La manopola parte SUBITO, e intanto si chiede il premio al
// server: il colore della pallina E' il premio, quindi dev'essere noto
// prima che esca — Gumball.jsx continua a girare la manopola finche' la
// risposta non arriva. Se il server rifiuta, il giro si ferma e si dice
// perche'.
// ============================================================
// Una richiesta alla volta: chiusa con Esc mentre il server risponde, una
// seconda giocata partita subito si prenderebbe il premio della prima.
let inAttesa = false

export function avviaGiro() {
  if (gumballStore.get() !== 'ferma' || inAttesa) return false
  // gia' giocato: la scritta sotto il mirino dice quando si potra' (Hud), la
  // manopola da' uno strattone e non gira
  if (giaGiocato()) {
    manopolaBloccata.da = performance.now()
    return false
  }
  const vera = statoGumballStore.get().vera
  // SPENTA: la macchinetta c'e' ma non gioca. Prima qui si usciva in silenzio,
  // e premendo E non succedeva niente — con la macchinetta sempre in scena
  // quel silenzio diventerebbe un difetto. Strattone alla manopola e una riga
  // che dice perche'.
  if (!vera && !DEBUG_MODE) {
    manopolaBloccata.da = performance.now()
    avvisa('La macchinetta non è ancora in funzione.')
    return false
  }
  premioGumballStore.set(null)
  gumballStore.set('gira')
  if (!vera) {
    premioGumballStore.set(pescaProva())
    return true
  }

  inAttesa = true
  fetch('/api/gumball', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ anteprima: DEBUG_MODE }),
  })
    .then(async (r) => {
      const j = await r.json().catch(() => ({}))
      if (j.prossima) statoGumballStore.set({ ...statoGumballStore.get(), prossima: j.prossima })
      if (!r.ok || !j.premio) throw new Error(j.errore || 'inceppata')
      premioGumballStore.set(j.premio)
      // chiusa con Esc mentre girava: il premio e' comunque suo (il codice
      // finisce nel carrello lo stesso), glielo si dice a parole
      if (gumballStore.get() === 'ferma' && j.premio.codice) {
        avvisa(`Hai vinto: ${j.premio.titolo}. Il codice è nel carrello.`)
      }
    })
    .catch(() => {
      if (gumballStore.get() === 'gira') gumballStore.set('ferma')
      avvisa(giaGiocato()
        ? `Hai già giocato: torna ${fraQuanto(statoGumballStore.get().prossima)}.`
        : 'La macchinetta si è inceppata. Riprova fra poco.')
    })
    .finally(() => { inAttesa = false })
  return true
}

export function chiudiPremio() {
  if (gumballStore.get() === 'ferma') return
  gumballStore.set('ferma')
  relockPointer()
}
